export const OneDriveConfig = {
    "ClientID": "afa58591-2ec3-41ad-9321-4b3ed8a47fbc",
    "ClientSecret": "3IRkbv_a1dMY~_G.64-Ph1Lnx47R-nW4K_",
    "RedirectEndpoint": "/settings/microsoftcallback",
    "Scopes": "files.readwrite.all offline_access"
}